import { ValueFormatterParams } from 'ag-grid-community';
import { FC } from 'react';
import {
  Buttons,
  Page,
  TableWrapper,
} from '../../../../common/TableWithButtonsRightLayout/TableWithButtonsRightLayout.styles';
import Export from '../../../../components/Export/Export';
import Table from '../../../../components/Table/Table';
import { ConfirmationProps } from './Confirmation.types';

const Confirmation: FC<ConfirmationProps> = ({ rowData }) => {
  const columnDefs = [
    { minWidth: 220, flex: 1, field: 'mxref', headerName: 'Store No.' },
    { minWidth: 320, flex: 2, field: 'status', headerName: 'Status' },
    {
      minWidth: 220,
      flex: 1,
      field: 'updatedDate',
      headerName: 'Date/Time',
      resizable: false,
      valueFormatter: (params: ValueFormatterParams) =>
        params.value
          ? `${new Date(params.value).toLocaleDateString()} ${new Date(params.value).toLocaleTimeString()}`
          : '',
    },
  ];

  return (
    <Page data-testid='ConfirmationPage'>
      <TableWrapper>
        <Table floatingFiltersHeight={0} returnedRecords={rowData?.length} columnDefs={columnDefs} rowData={rowData} />
      </TableWrapper>
      <Buttons>
        <Export
          columnHeaders={columnDefs.map((col) => {
            return { field: col.field, headerName: col.headerName };
          })}
          rowData={rowData || []}
        />
      </Buttons>
    </Page>
  );
};

export default Confirmation;
